import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BaseElement from '../BaseElement/BaseElement';
import _ from 'lodash';
import shallowEqual from 'fbjs/lib/shallowEqual';


function getText(elementProps) {
  return elementProps.data.text;
}

function getEditBoxStyles(elementProps) {
  return {..._.omit(elementProps.compProps, 'zIndex'), ...elementProps.data.compProps};
}

function getTextSetter(html) {
  return {
    data: {
      text: html
    }
  };
}

class TitleElement extends Component {
  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  getText() {
    const {publish, data} = this.props;
    if (data.templateTagData && _.isEmpty(data.listingData) && !data.draft) {
      if (publish) {
        return data.templateTagData.tag;
      }
      return data.templateTagData.placeholder;
    }
    return data.text;
  }

  render() {
    const {data, editingTextElement} = this.props;
    let {compProps} = this.props;
    const text = this.getText();
    let overflowY;
    if (data.templateTagData) {
      overflowY = 'auto';
    }
    if (editingTextElement) {
      // when text is being edited, a copy of the comp is rendered on top of the mouse catcher
      compProps = {
        ...compProps,
        opacity: 0,
      };
    }
    return (
      <BaseElement {...this.props} compProps={{...compProps, wordWrap: 'break-word', overflowY}}>
        <div style={data.compProps}
             dangerouslySetInnerHTML={{__html: text}}></div>
      </BaseElement>
    );
  }
}

TitleElement.propTypes = {
  id: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }),
  data: PropTypes.shape({
    text: PropTypes.string.isRequired,
    compProps: PropTypes.object,
    href: PropTypes.string,
  }),
  editingTextElement: PropTypes.bool,
};

TitleElement.defaultProps = {
  data: {
    text: ''
  }
};

export default {
  elementClass: TitleElement,
  methods: {
    getText,
    getEditBoxStyles,
    getTextSetter,
  }
};